const donationBox = () => {
  const main = document.querySelector('.donation-box');

  const buttons = main.querySelectorAll('button[type=button]');
  const donationImport = main.querySelector('input[type=number]');
  buttons.forEach(button => button.addEventListener('click', () => {
    donationImport.setAttribute('value', parseInt(button.getAttribute('data-value'), 10));
  }));
};

export default donationBox;
